import { StyledBannerSlide } from "./StyledComponents";
import { useEffect, useState } from "react";
import { findLinkById } from "../../../assets/store/findLink";

function BannerSlide({
    slide,
    banner_image,
    index,
    dataAttributes,
    sunbit,
    dignifi,
    sunbitId,
    links,
}) {
    const [bannerOnClick, setBannerOnClick] = useState(null);
    const {
        url_id,
        url,
        selected_url,
        open_link_in_new_tab,
        include_url,
        use_phone_number,
        phone_number,
        open_sunbit_modal, 
        open_dignifi_modal,
    } = slide;

    const { number } = phone_number || {};
    const isClickToCall = (number && include_url && use_phone_number);
    const slideUrl = url_id ? selected_url.link : url;

    const bannerTarget = findLinkById({
        links,
        linkType: url_id,
    })?.open_link_in_new_tab;

    const bannerSlideDataAttr = include_url && {
        ...dataAttributes,
        "data-clickurl": url || "No Banner Link",
    };

    useEffect(() => {
        const slideOpenModal =
            (sunbit && open_sunbit_modal) || (dignifi && open_dignifi_modal);
        if (slideOpenModal) {
            const modalType = sunbit ? "dss-sunbit" : "dignifi";

            return setBannerOnClick(() => () => {
                const modal = document.getElementById(`${modalType}-modal-content`);
                if (modal) modal.style.display = "block";
            });
        } else setBannerOnClick(() => handleClick);
    }, []);

    const handleClick = () => {
        if (!include_url) return;
        if (use_phone_number && number) return window.open("tel:" + number, "_self");
        if (slideUrl) {
            let openInNewTab = "_self";
            if (bannerTarget || (open_link_in_new_tab && url)) openInNewTab = "_blank";

            return window.open(slideUrl, openInNewTab);
        }
    };

    return (
        <StyledBannerSlide
            includeUrl={include_url}
            data-testid="fod-banner-slide"
            data-ascmediatype="slider"
            data-clickurl={include_url && slideUrl ? slideUrl : null}
            data-ascphonenumber={isClickToCall ? number : null}
            data-ascclicktocall={isClickToCall}
            src={banner_image}
            alt="Banner Image"
            {...bannerSlideDataAttr}
            className={
                include_url
                    ? "FODGABannerSlide FODV5GABannerSwiperClickEvent"
                    : "FODGABannerSlide"
            }
            onClick={bannerOnClick}
        ></StyledBannerSlide>
    );
}

export default BannerSlide;
